import { useMemo } from 'react'
import { slugs } from '@/constants/slugs'

interface BasicHeroData {
  bgVideoUrl: string
  fallbackImageUrl: string
  logo: {
    url: string
    class: string
    width: number
    height: number
  }
}

const data = {
  [slugs.david]: {
    bgVideoUrl:
      'https://images.angelstudios.com/video/upload/q_auto:eco,f_auto,br_2m/v1765245269/david-bg-video_jmtkhw.mp4',
    fallbackImageUrl: '/v1760542947/theatrical/david/david-hand-img-01.webp',
    logo: {
      url: '/v1764102078/theatrical/david/david-logo-color-800m.webp',
      class: 'h-[45px] w-[180px] md:h-[45px] md:w-[180px] lg:h-[66px] lg:w-[265px]',
      width: 265,
      height: 66,
    },
  },
  [slugs.soloMio]: {
    bgVideoUrl:
      'https://images.angelstudios.com/video/upload/v1766007899/theatrical/solo%20mio/solo-mio-looping-video-v2.mp4',
    fallbackImageUrl: '/v1766081230/theatrical/solo%20mio/solo-mio-loop-img-01.png',
    logo: {
      url: '/v1747322734/studio-app/catalog/ac231679-9bc9-495f-9258-c6c21fc0ad94',
      class: 'h-[33px] w-[200px] md:h-[36px] md:w-[221px] lg:h-[47px] lg:w-[287px]',
      width: 287,
      height: 47,
    },
  },
  [slugs.iWasAStranger]: {
    bgVideoUrl:
      'https://images.angelstudios.com/video/upload/v1766007929/theatrical/stranger/stranger-loop-video-v2.mp4',
    fallbackImageUrl: '/v1766081312/theatrical/stranger/stranger-loop-img-01.png',
    logo: {
      url: '/v1758752785/studio-app/catalog/90767562-3c8f-4e42-a40a-d0bcab0e685e',
      class: 'h-[57px] w-[188px] md:h-[67px] md:w-[220px] lg:h-[81px] lg:w-[265px]',
      width: 265,
      height: 81,
    },
  },
}

export const useBasicHeroData = (slug: string): BasicHeroData | null => {
  return useMemo(() => data[slug] ?? null, [slug])
}
